import {
  Component,
  OnInit,
  Input,
  HostListener,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  NgZone,
  ChangeDetectorRef,
  Inject,
  OnDestroy,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { LabService } from '../../../services/lab.service';
import { CodeBlockPopupComponent } from '../code-block/code-block-popup.component';
import { enhanceCodeBlock, getFenceLanguage } from '../code-block/code-block.util';
import {
  CustomerType,
  Deployment,
  EnvironmentLayout,
  Lab,
  DocGuideErr,
} from '../../../modals/lab.model';
import { MarkdownService } from 'ngx-markdown';
import { ClipboardService } from 'ngx-clipboard';
import { TranslateService } from '@ngx-translate/core';
import { EventService } from '../../../services/event.services';
import {
  getEntity,
  getEntityData,
  htmlDecode,
  manageServiceVariables,
  stringToHtml,
  unsubscribeCollection,
} from '@utility';
import { NotificationService } from '../../../services/notification.service';
import { RemoteDesktopManager } from '../../../lib/remote';
import { EventEmitterService, UserSessionService } from '@teams-auth';
import { Subject, Subscription } from 'rxjs';
import { GithubDataService, CommonService } from '@utility';
import { ToastrService } from 'ngx-toastr';
declare const $: any;
import * as moment from 'moment';
import { CommonService as CommonServicePT } from '@questions-ui';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DurationDialogComponent } from '../duration-dialog/duration-dialog.component';
import { ButtonLoadingService } from '@teams-ui-angular';
@Component({
  selector: 'cloudlabs-doc-guide',
  templateUrl: './doc-guide.component.html',
  styleUrls: ['./doc-guide.component.scss'],
})
export class DocGuideComponent implements OnInit, OnChanges, OnDestroy {
  @Input() type: string;
  @Input() labDetail: Lab;
  @Input() voucherCode: string;
  @Input() lang: string;
  @Input() manager: RemoteDesktopManager;
  @Input() guideData: Deployment;
  @Input() isSidenav = false;
  @Input() mode;
  @Input() layoutType: string;
  @Input() isMobile: boolean;
  @Input() showResourcesTab: boolean;
  @Input() pasteInVM: boolean;
  @Input() uniqueName: string;
  @Input() isComplete: boolean;
  public pageNumber: number;
  @Output() pageNumberVal = new EventEmitter<number>();
  @Output() actionClickEvent = new EventEmitter<string>();
  // @Input() overallLabGuide: any

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onLoadingComplete = new EventEmitter();
  @Output() labIsCompleted = new EventEmitter<string>();
  @Output() spliLabIsCompleted = new EventEmitter<string>();
  @Output() collapseSideBar = new EventEmitter();
  @Input() splitKey: string;
  @Input() set initialDeployment(initialDeployment: Deployment) {
    this.initialDeploymentData = initialDeployment;
  }
  @Output() tabChange = new EventEmitter();
  @Output() overallLabGuideEmit = new EventEmitter();

  public loading = false;
  public minGuide = true;
  public tabView = 'guide';
  public osInfo: string;
  public currentTab: any;
  public itemsPerPage = 5;
  public showDropdown = false;
  public labGuideData = [];
  public p = 1;
  public gitHUbdocs: any;
  public guideTab: any = [];
  public EdgeMessage = false;
  public FirefoxHelpMessage = false;
  public attendeLabDetails: any;
  public IsSupportQuestFlag: boolean;
  public defaultProps = {
    style: '',
    enableCopy: true,
    enableClicktoPaste: false,
  };
  appType: string;
  @ViewChild('codeBlockPopup') codeBlockPopup: CodeBlockPopupComponent;
  private notifier = new Subject();
  vmTabKey: string;
  // currentGuideKey: string;
  @Input() isSplitScreen = false;
  public index: any;
  public validationPattern = /(<validation[^>]*>)/;
  @Input() isMylearning;
  @Output() splitScreen = new EventEmitter();
  @Output() joinScreen = new EventEmitter();
  @Output() valueChangedPageNumber = new EventEmitter<string>();
  public environmentLayout = EnvironmentLayout;
  public customerType = CustomerType;
  private initialDeploymentData: Deployment;
  public currentLabguide = [];
  public groupedQuestPattern = /(<grouped-questions[^>]*>)/;
  public ungroupedQuestPattern = /(<question[^>]*>)/;
  public inlineVideoPattern = /(<inline-video[^>]*>)/;
  public testPattern =
    /(<validation[^>]*>)|(<grouped-questions[^>]*>)|(<question[^>]*>)|(<inline-video[^>]*>)/;
  public mdPath: any = [];
  public mdPathGroup: any = [];
  showSplitWindow = true;
  public videoPath: any = [];
  public videoWidth: any = [];
  public videoHeight: any = [];
  zoomLevel = 1;
  public pathFileName: string;
  private subscriptions: Subscription[] = [];
  private vmurl: string;
  private internalId: string;
  public progressData: any;
  isInlinequestionsLoading = false;
  private clid: string;
  private clVcode: string;
  public disablePaginationControls: boolean;
  public totalPages: string;
  public showDelete = false;
  public docGuideErr = DocGuideErr;
  public deploymentID: number;
  panelStates: { [key: number]: boolean } = {};
  public modalRef: BsModalRef;
  activePageIndex = 0;
  pageSeconds = 0;
  remainingSeconds = 0;

  @HostListener('document:click', ['$event'])
  async handleClick($event) {
    if ($event.target.id !== 'showdropdown-menu') {
      this.showDropdown = false;
    }
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.updatePreHeights();
  }

  constructor(
    private LabSrv: LabService,
    public markdownService: MarkdownService,
    private _clipboardService: ClipboardService,
    private translateSrv: TranslateService,
    private notificationService: NotificationService,
    private eventSrv: EventService,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef,
    private userSessionService: UserSessionService,
    private gitHubSrv: GithubDataService,
    private commonSrv: CommonService,
    private eventEmitter: EventEmitterService,
    private tostrSrv: ToastrService,
    private commonServicePT: CommonServicePT,
    private route: Router,
    public el: ElementRef,
    private location: Location,
    private aroute: ActivatedRoute,
    private modalService: BsModalService,
    public btnLoadingService: ButtonLoadingService,
    @Inject('environment') public environment
  ) {
    $('li.dropdown').hide();
    this.appType = environment.appType;
    this._clipboardService.copyResponse$.subscribe((re) => {
      if (re.isSuccess && !this.pasteInVM) {
        this.notificationService.success(
          this.translateSrv.instant('MESSAGE_COPIED'),
          null
        );
      }
    });
    this.disablePaginationControls = false;
    this.osInfo = '';
    this.subscriptions[this.subscriptions.length] =
      this.aroute.params.subscribe((i) => {
        this.vmurl = i.vmurl;
        this.internalId = i.id;
        this.pageNumber = this.aroute.snapshot.params?.pageNumber && this.aroute.snapshot.params?.pageNumber !== 'undefined'
          ? this.aroute.snapshot.params?.pageNumber
          : 1;
        this.pageNumberVal.emit(this.pageNumber);
        // this.eventSrv.isPageNumberChange(this.pageNumber)
        this.clid = i.clid;
        this.clVcode = i.clVcode;
        this.voucherCode = i.voucherCode;
        // this.pageNumber = i.pageNumber
        this.p = this.pageNumber;
        if (this.gitHUbdocs) {
          this.maxPages();
          this, this.loadMdFiles();
        }
      });
    this.eventSrv.setVoucherCode(this.voucherCode);
  }

  async ngOnInit() {
    this.p = this.pageNumber;
    this.subscriptions[this.subscriptions.length] =
      this.eventSrv.windowJoin.subscribe((res) => {
        if (!this.isInlinequestionsLoading) {
          const pageNum = localStorage.getItem('pageNumber' + this.voucherCode);
          if (pageNum !== undefined && pageNum !== null) {
            this.pageNumber = Number(pageNum);
            this.p = this.pageNumber;
          } else {
            this.p = this.pageNumber;
          }
          // setTimeout(() => {
            const page = this.p > 0 ? this.p - 1 : 1;
            const path = this.gitHUbdocs.Files[page].RawFilePath;
            this.pathFileName = path.split('/').pop();
            this.loadMdFiles();
            this.isInlinequestionsLoading = true;
          // }, 10);
          this.updatePreHeights();
        }
        setTimeout(() => {
          this.isInlinequestionsLoading = false;
        }, 2000);
      });
    // this.eventSrv.labGuides$.subscribe((progress) => {
    //   if (progress) {
    //     this.progressData = progress
    //   }
    // })
    this.eventSrv.tabProgress$.subscribe((tabProgress) => {
      if (tabProgress === 'progress') {
        this.tabView = 'progress';
      }
    });
    if (
      this.route.url.includes('virtual-machine') ||
      this.route.url.includes('template')
    ) {
      this.showSplitWindow = false;
    }
    this.detectOS();
    this.vmTabKey = `vmTab_${this.labDetail.UniqueName}_${this.voucherCode}`;
    // this.currentGuideKey = `currentPage_${this.labDetail.UniqueName}_${this.voucherCode}`;
    this.lang = localStorage.getItem('language') || 'en';
    this.currentTab = localStorage.getItem(this.vmTabKey);
    this.loading = true;
    this.IsSupportQuestFlag = this.labDetail.IsSupportQuest;

    // ui reflect changes
    await this.ngZone.run(async () => {
      await this.getLabDocs();
    });

    this.attendeLabDetails = await this.LabSrv.getLabEnvironment(
      this.labDetail.UniqueName,
      this.voucherCode
    ).toPromise();
    this.createTab();
    setTimeout(() => {
      this.loading = false;
    }, 1000);
    this.eventSrv.changeTab.subscribe((res) => {
      setTimeout(() => {
        // manage dynamic tabs calculation
        this.reFlow();
        $(window).on('resize', this.reFlow);
        $(window).on('resize-tabs', this.reFlow);
      }, 500);
    })

    setTimeout(() => {
      // manage dynamic tabs calculation
      this.reFlow();
      $(window).on('resize', this.reFlow);
      $(window).on('resize-tabs', this.reFlow);
    }, 1500);

    $(document).ready(() => {
      if (/Edge/.test(navigator.userAgent)) {
        this.EdgeMessage = true;
      }
      if (navigator.userAgent.indexOf('Firefox') !== -1) {
        this.FirefoxHelpMessage = true;
      }
    });
    this.onLoadingComplete.emit(true);
    this.subscriptions[this.subscriptions.length] =
      this.eventSrv.windowJoin.subscribe(() => {
        this.getVmTab();
        // if (!this.currentLabguide[this.p]) {
        //   this.loadMdFiles();
        // }
      });
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 1000);
    this.userSessionService.vmRenderOnLeftPanelChange$.subscribe(
      (boolValue) => {
        setTimeout(() => {
          this.reFlow();
        }, 1500);
      }
    );
    this.translateSrv.onLangChange.subscribe(async () => {
      this.reloadLabguide();

      // old code for language change
      // setTimeout(() => {
      //   this.getLabDocs();
      //   this.reFlow();
      // }, 1500);
    });
    this.eventSrv.changeTab.subscribe((res) => {
      this.tabView = 'environment';
      this.tabChange.next(this.tabView);
    });
    this.eventSrv.zoomLevel.subscribe((res: any) => {
      if (res) {
        this.zoomLevel = res.value;
        this.commonSrv.applyFontSize(this.el, this.zoomLevel, '#guideView');
        this.updatePreHeights();
      }
    });
    if (this.labDetail?.EnableLabProgress) {
      this.getLabGuideProgress();
    }
    this.eventSrv.resizeSidebar.subscribe((res) => {
      this.reFlow();
    });
    this.eventSrv.totalGuidePages.subscribe((total) => {
      this.totalPages = String(total);
    });
    this.showDelete = this.labDetail.AllowUserToDeleteODL ? true : false;
    this.deploymentID =
      this.initialDeploymentData?.AllocatedTestDriveViewModalDetails[0]?.CloudUserId;
      this.eventSrv.changeTab.subscribe((res) => {
        setTimeout(() => {
          // manage dynamic tabs calculation
          this.reFlow();
          $(window).on('resize', this.reFlow);
          $(window).on('resize-tabs', this.reFlow);
        }, 500);
      })
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      for (const key in changes) {
        if (
          Object.prototype.hasOwnProperty.call(changes, key) &&
          changes[key].currentValue
        ) {
          this[key] = changes[key].currentValue;
        }
        if (
          !changes[key].isFirstChange() &&
          key === 'lang' &&
          (changes[key].currentValue ||
            // eslint-disable-next-line no-prototype-builtins
            (changes[key].hasOwnProperty('previousValue') &&
              changes[key].currentValue !== changes[key].previousValue))
        ) {
          // Old code for language changed
          // this.loading = true;
          // this.labGuideData = [];
          // this.gitHUbdocs = null;
          // this.p = 0;
          // this.guideTab = [];
          // this.currentLabguide = [];
          // await this.getLabDocs();
          // this.createTab();
          // // await this.ngOnInit();
          // this.loading = false;
          // setTimeout(() => {
          //   window.dispatchEvent(new Event('resize-tabs'));
          // }, 100);
        }
        if (key === 'showResourcesTab') {
          if (!this.showResourcesTab) {
            const index = this.guideTab.findIndex((item) => item.id === 4);
            if (index !== -1) {
              this.guideTab.splice(index, 1);
              this.cdr.detectChanges();
            }
          }
        }
      }
      if (changes?.isComplete && changes?.isComplete.currentValue) {
        this.stopPageTimer();
      }
    }
    this.cdr.detectChanges();
  }

  initializeTotalRemainingTime() {
    const start = moment.utc(this.guideData.StartTime);
    const now = moment.utc();
    const diffSeconds = now.diff(start, 'seconds');

    const totalPageDuration = this.gitHUbdocs.Files.reduce((sum, item) => {
      return sum + (item.PageDuration || 0);
    }, 0);

    let labDuration = this.labDetail.Duration;
    if (labDuration > totalPageDuration) {
      labDuration = totalPageDuration; // removed buffer time
    }

    const totalAllowed = labDuration * 60;
    this.remainingSeconds = totalAllowed - diffSeconds;
  }

  async handlePageChangeLogic() {
    this.stopPageTimer();
    this.initializeTotalRemainingTime();

    const currentIndex = this.activePageIndex;
    const page = this.gitHUbdocs.Files[currentIndex];

    const data = (await this.LabSrv.getNavigationAnalyticsExtended(
      this.voucherCode,
      this.p
    ).toPromise()) as any;
    page.isCompleted = data.IsPageCompleted;

    if (page.isCompleted) {
      this.pageSeconds = 0;
      return;
    }

    let futurePagesSum = 0;
    for (let i = currentIndex + 1; i < this.gitHUbdocs.Files.length; i++) {
      futurePagesSum += this.gitHUbdocs.Files[i].PageDuration ?? 0;
    }

    this.pageSeconds = this.remainingSeconds - futurePagesSum * 60;
    if (this.pageSeconds <= 0 && !page.isCompleted) {
      this.showDurationDialog();
    }
    this.startPageTimer();
  }

  startPageTimer() {
    const page = this.gitHUbdocs.Files[this.activePageIndex];
    this.eventSrv.start(() => {
      this.pageSeconds--;
      this.remainingSeconds--;

      if (this.pageSeconds === 0 && !page.isCompleted) {
        page.expiredShown = true;
        this.showDurationDialog();
      }
    }, 1000);
  }

  stopPageTimer() {
    this.eventSrv.stop();
  }

  markAsComplete() {
    this.btnLoadingService.indexValue = 'markComplete';
    this.btnLoadingService.setLoding(
      true,
      this.translateSrv.instant('MARK_COMPLETE')
    );
    const page = this.gitHUbdocs.Files[this.activePageIndex];
    // page.isCompleted = true;

    const payload = {
      VoucherCode: this.voucherCode,
      VisitedPageNumber: this.p,
      TotalPages: this.gitHUbdocs.Files.length,
      VisitedTime: moment.utc().format(),
      IsPageCompleted: true,
    };

    this.LabSrv.createNavigationAnalyticsExtended(payload).subscribe(
      () => {
        this.stopPageTimer();
        page.isCompleted = true;
        this.btnLoadingService.buttonLodingOff();
      },
      () => {
        this.btnLoadingService.buttonLodingOff();
      }
    );
  }

  showDurationDialog() {
    this.modalRef = this.modalService.show(DurationDialogComponent, {
      initialState: {
        title: this.translateSrv.instant('CAUTION'),
        data: {
          description:
            this.gitHUbdocs.LabGuidePageDurationNotificationMessage ??
            this.translateSrv.instant('DURATION_ALLOCATED_DEC'),
          successButtonText: this.translateSrv.instant('OK'),
        },
      },
    });
  }

  async reloadLabguide() {
    this.loading = true;
    this.labGuideData = [];
    this.gitHUbdocs = null;
    this.eventSrv.totalGuidePages.next(this.gitHUbdocs?.Files.length);
    this.p = 1;
    this.currentLabguide = [];
    await this.getLabDocs();
    this.loading = false;
    setTimeout(() => {
      window.dispatchEvent(new Event('resize-tabs'));
    }, 100);
  }

  splitWindow() {
    this.splitScreen.emit();
    this.stopPageTimer();
  }

  joinWindow() {
    this.joinScreen.emit();
  }

  createTab() {
    if (this.guideData?.IsGitDocAvailable == true) {
      this.guideTab.push({
        id: 1,
        link: 'guide',
        // title: 'HEADING_LAB_GUIDE',
        title: 'HEADING_GUIDE', // Change Lab Guide to Guide | Task-5102
        selected: true,
      });
    }
    if (this.labDetail) {
      this.guideTab.push({
        id: 2,
        link: 'environment',
        title: 'TAB_ENVIRONMENT_DETAILS',
        selected: false,
      });
    }
    if (
      this.labDetail?.EnableLabValidation === true &&
      !this.labDetail?.DisableValidationTab &&
      !this.IsSupportQuestFlag
    ) {
      this.guideTab.push({
        id: 3,
        link: 'validation',
        title: 'TAB_LAB_VALIDATION',
        selected: false,
      });
    }
    if (
      // this.progressData?.TotalQuestions > 0 || this.progressData?.TotalValidations > 0
      this.labDetail?.EnableLabProgress
    ) {
      this.guideTab.push({
        id: 4,
        link: 'progress',
        title: 'TAB_PROGRESS',
        selected: false,
      });
    }
    // if (
    //   (!this.guideData?.IsSharedTestDrive &&
    //     this.attendeLabDetails.CloudPlatformId === 1) ||
    //   this.guideData.CloudPlatformId == 1 ||
    //   this.guideData.CloudPlatformId == 2 ||
    //   this.guideData.CloudPlatformId == 3 ||
    //   (!this.guideData?.IsSharedTestDrive &&
    //     (this.attendeLabDetails.CloudPlatformId === 1 ||
    //       this.attendeLabDetails.CloudPlatformId === 2))
    // ) {

    if (this.showResourcesTab) {
      this.guideTab.push({
        id: 5,
        link: 'resources',
        title: 'TAB_RESOURCES',
        selected: false,
      });
    }
    // }
    if (this.labDetail) {
      this.guideTab.push({
        id: 6,
        link: 'help',
        title: 'HELP',
        selected: false,
      });
    }
    if (this.labDetail.LabLaunchPageDescription) {
      this.guideTab.unshift({
        id: 7,
        link: 'description',
        title: 'LAB_DESCRIPTION_TAB',
        selected: true,
      });

      if (!this.isSplitScreen) {
        localStorage.setItem(this.vmTabKey, 'description');
        this.tabView = 'description';
      }
    }
    this.tabChange.next(this.tabView);
  }

  getcalue() {
    const totalPages = this.gitHUbdocs.Files.length;
    if (this.p > totalPages || Number(this.pageNumber) === 0) {
      this.pageNumber = this.p = 1;
    } else {
      this.pageNumber = this.p;
    }
    this.showDelete = this.labDetail.AllowUserToDeleteODL ? true : false;
    this.pageNumberVal.emit(this.p);
    this.isSplitScreen
      ? localStorage.setItem(
          'pageNumber' + this.voucherCode,
          String(this.pageNumber)
        )
      : localStorage.removeItem('pageNumber' + this.voucherCode);
    if (this.isMylearning) {
      if (getEntityData() === 'courses') {
        this.location.replaceState(
          getEntity() +
            `/` +
            getEntityData() +
            `/${this.clid}/${this.clVcode}/${this.internalId}/${this.voucherCode}/labenvironment/${this.vmurl}/${this.p}`
        );
      } else {
        this.location.replaceState(
          getEntity() +
            `/` +
            getEntityData() +
            `/${this.internalId}/${this.voucherCode}/labenvironment/${this.vmurl}/${this.p}`
        );
      }
    } else {
      if (!this.isSplitScreen) {
        this.location.replaceState(
          `/odl/environment/${this.internalId}/${this.voucherCode}/${this.vmurl}/${this.p}`
        );
      }
    }
    this.navigationAnalytics();
    const page = this.p - 1;
    const path = this.gitHUbdocs.Files[page].RawFilePath;
    let texting = path.substring(0, path.lastIndexOf('/'));
    this.pathFileName = path.split('/').pop();
    this.loadMdFiles();
    this.markdownService.renderer.image = (
      href: string,
      title: string,
      text: string
    ) => {
      if (!texting.endsWith('/')) {
        texting += '/';
      }
      let resolvedHref =
        href.startsWith('http://') || href.startsWith('https://')
          ? href
          : new URL(href, texting).href;
      if (
        resolvedHref.includes('docs-api.cloudlabs.ai') ||
        resolvedHref.includes('docs-api-qa.cloudlabs.ai')
      ) {
        resolvedHref +=
          (resolvedHref.includes('?') ? '&' : '?') +
          `token=${this.environment.privateRepoAccessToken}`;
      }
      return `<img alt="${title || text}" src="${resolvedHref}">`;
    };
    const el = $(`#guideView`);
    el.animate({ scrollTop: 0 });
    setTimeout(() => {
      this.handleLabGuideElements(texting);
    }, 500);
    el.focus();
  }

  navigationAnalytics() {
    const data = {
      VoucherCode: this.voucherCode,
      VisitedPageNumber: this.p,
      TotalPages: this.gitHUbdocs.Files.length,
      VisitedTime: moment.utc().format(),
    };
    this.LabSrv.createNavigationAnalytics(data).subscribe();
  }

  async updatePageLock() {
    this.gitHUbdocs = await this.LabSrv.getGitHubDocs(
      this.labDetail.UniqueName,
      this.voucherCode
    );
    this.eventSrv.totalGuidePages.next(this.gitHUbdocs.Files.length);
    this.checkUnlockingRules();
  }

  checkUnlockingRules() {
    const filteredGuides = this.gitHUbdocs.Files.filter(
      (guide) => guide.HasUnlockingRules
    ).map((guide) => guide.Order);

    this.eventSrv.lockPages.next(filteredGuides);

    setTimeout(() => {
      this.maxPages();
      const page = this.p > 0 ? this.p - 1 : 1;
      const path = this.gitHUbdocs.Files[page].RawFilePath;
      const texting = path.substring(0, path.lastIndexOf('/'));
      this.pathFileName = path.split('/').pop();
      this.handleLabGuideElements(texting);
    }, 100);
  }

  loadMdFiles() {
    this.mdPath = [];
    this.mdPathGroup = [];
    if(typeof(this.p) === 'string') {
      this.p = Number(this.p)
    }
    const page = this.p > 0 ? this.p - 1 : 1;
    if (!this.currentLabguide[this.p]) {
      this.disablePaginationControls = true;
      this.gitHubSrv
        .getGitHubData(this.gitHUbdocs.Files[page].RawFilePath)
        .subscribe(
          (res) => {
            this.currentLabguide[this.p] = res;
            const path = this.gitHUbdocs.Files[page].RawFilePath;
            const texting = path.substring(0, path.lastIndexOf('/'));
            this.pathFileName = path.split('/').pop();
            setTimeout(() => {
              this.commonSrv.applyFontSize(
                this.el,
                this.zoomLevel,
                '#guideView'
              );
              this.handleLabGuideElements(texting);
            }, 3000);

            if (this.labDetail?.HasInlineQuestions) {
              this.currentLabguide[this.p]
                ?.split(this.ungroupedQuestPattern)
                .forEach((element) => {
                  if (this.ungroupedQuestPattern.test(element)) {
                    this.mdPath.push({
                      md: this.getSourcePath(element),
                    });
                  }
                });
              this.currentLabguide[this.p]
                ?.split(this.groupedQuestPattern)
                .forEach((element) => {
                  if (this.groupedQuestPattern.test(element)) {
                    this.mdPathGroup.push({
                      md: this.getSourcePath(element),
                    });
                  }
                });
              this.getlabguideQuestion();
            }
            this.currentLabguide[this.p]
              ?.split(this.inlineVideoPattern)
              .forEach((element) => {
                if (this.inlineVideoPattern.test(element)) {
                  this.videoPath.push(this.getSourcePath(element));
                  this.videoWidth.push(this.getWidth(element));
                  this.videoHeight.push(this.getHeight(element));
                }
              });
            this.disablePaginationControls = false;
          },
          (err) => {
            this.disablePaginationControls = false;
            this.currentLabguide[this.p] =
              'Error: One or more documents not found';
            const code = 'Error - 70018';
            this.eventEmitter.debugAlert(code, err.error);
          }
        );
    } else if (this.labDetail?.HasInlineQuestions) {
      this.currentLabguide[this.p]
        ?.split(this.ungroupedQuestPattern)
        .forEach((element) => {
          if (this.ungroupedQuestPattern.test(element)) {
            this.mdPath.push({
              md: this.getSourcePath(element),
            });
          }
        });
      this.currentLabguide[this.p]
        ?.split(this.groupedQuestPattern)
        .forEach((element) => {
          if (this.groupedQuestPattern.test(element)) {
            this.mdPathGroup.push({
              md: this.getSourcePath(element),
            });
          }
        });
      this.getlabguideQuestion();
      this.currentLabguide[this.p]
        ?.split(this.inlineVideoPattern)
        .forEach((element) => {
          if (this.inlineVideoPattern.test(element)) {
            this.videoPath.push(this.getSourcePath(element));
            this.videoWidth.push(this.getWidth(element));
            this.videoHeight.push(this.getHeight(element));
          }
        });
    }
    this.activePageIndex = this.p - 1;
    if (
      this.gitHUbdocs.EnableLabGuidePageDuration &&
      this.gitHUbdocs.Files[this.activePageIndex].PageDuration &&
      this.gitHUbdocs.Files[this.activePageIndex].PageDuration > 0
    ) {
      this.stopPageTimer();
      this.handlePageChangeLogic();
    }
  }

  /**
   * get lab docs md file
   */
  async getLabDocs() {
    if (
      this.guideData.IsGitDocAvailable == true
      // Commenting this code for Databrick WorkSpace - Vijay Chaudhary (320)
      //|| !this.labDetail.EnableAccessOverHttp
    ) {
      this.labGuideData = [];
      this.gitHUbdocs = null;
      this.gitHUbdocs = await this.LabSrv.getGitHubDocs(
        this.labDetail.UniqueName,
        this.voucherCode
      );
      this.eventSrv.totalGuidePages.next(this.gitHUbdocs.Files.length);
      if (
        this.labDetail.EnableInlineValidation ||
        this.labDetail.HasInlineQuestions
      ) {
        this.checkUnlockingRules();
      }
      this.navigationAnalytics();
      if (this.gitHUbdocs.EventName && this.gitHUbdocs.EventName !== '') {
        this.LabSrv.guideTitle.next(this.gitHUbdocs.EventName);
      }
      if (this.gitHUbdocs.Files.length > 0) {
        this.gitHUbdocs.Files.sort((a, b) => a.Order - b.Order);
        this.getVmTab();
        // manage the markdown renderers
        const path = this.gitHUbdocs.Files[0].RawFilePath;
        const texting = path.substring(0, path.lastIndexOf('/'));
        this.pathFileName = path.split('/').pop();
        this.markdownService.renderer.code = (code: string, infostring?: string) => {
          const injectTagRegex =
            /<inject\s+(key="([^"]*)")?\s*(cloudname="([^"]*)")?\s*(style="([^"]*)")?\s*(enableCopy="([^"]*)")?\s*(enableClicktoPaste="([^"]*)")?\s*(defaultValue="([^"]*)")?\s*\/?>/gi;

          let style = '';
          let enableCopy = true;
          let enableClicktoPaste = false;

          code = code.replace(
            injectTagRegex,
            (
              _,
              keyAttr,
              key,
              cloudnameAttr,
              cloudnameValue,
              styleAttr,
              styleValue,
              enableCopyAttr,
              enableCopyValue,
              enableClicktoPasteAttr,
              enableClicktoPasteValue,
              defaultValueAttr,
              defaultValue
            ) => {
              key = key.replace(/ +/g, '').toLowerCase();
              cloudnameValue = cloudnameValue?.toLowerCase();
              defaultValue = defaultValue?.trim() || '';

              let deploymentOutputValues: any = {};
              let guideDataValues: any = {};
              let initialDeploymentValues: any = {};

              if (
                this.attendeLabDetails.AllocatedTestDriveViewModalDetails
                  .length > 1
              ) {
                deploymentOutputValues =
                  this.attendeLabDetails.AllocatedTestDriveViewModalDetails.find(
                    (item) =>
                      item.FriendlyName?.toLowerCase() === cloudnameValue
                  )?.DeploymentOutputValues;
                guideDataValues =
                  this.guideData.AllocatedTestDriveViewModalDetails.find(
                    (item) =>
                      item.FriendlyName?.toLowerCase() === cloudnameValue
                  );
                initialDeploymentValues =
                  this.initialDeploymentData.AllocatedTestDriveViewModalDetails.find(
                    (item) =>
                      item.FriendlyName?.toLowerCase() === cloudnameValue
                  );
              } else {
                deploymentOutputValues =
                  this.attendeLabDetails.AllocatedTestDriveViewModalDetails[0]
                    ?.DeploymentOutputValues;
                guideDataValues =
                  this.guideData.AllocatedTestDriveViewModalDetails[0];
                initialDeploymentValues =
                  this.initialDeploymentData
                    .AllocatedTestDriveViewModalDetails[0];
              }

              const replacements = {
                azureaduseremail: guideDataValues?.AADEmail || '',
                azureaduserpassword: guideDataValues?.TempPassword || '',
                accesskey: guideDataValues?.AADSPAppId || '',
                displayname: guideDataValues?.AADSPDisplayName || '',
                secretkey: guideDataValues?.AADSPAppKey || '',
                subscriptionid: guideDataValues?.SubscriptionGuid || '',
                tenantid: guideDataValues?.TenantId || '',
                tenantdomainname: guideDataValues?.TenantDomainName || '',
                cloudlabsdeploymentid:
                  initialDeploymentValues?.CloudUserId || '',
                aaddomain: guideDataValues?.AADDomain || '',
                resourcegroupregion: guideDataValues?.ResourceGroupRegion || '',
                ocisigninurl: `https://cloud.oracle.com/?tenant=${
                  guideDataValues?.TenantDomainName || ''
                }&domain=${guideDataValues?.AADDomain || ''}&amp;region=${
                  guideDataValues?.ResourceGroupRegion || ''
                }`,
              };

              // Iterate through OutputValues and add to replacements
              if (
                deploymentOutputValues &&
                Array.isArray(deploymentOutputValues)
              ) {
                deploymentOutputValues.forEach((deployment: any) => {
                  deployment.OutputValues.forEach((outputValue: any) => {
                    replacements[
                      outputValue.Name.replace(/ +/g, '').toLowerCase()
                    ] = outputValue.Value;
                  });
                });
              }

              // Update style if available
              if (styleAttr && styleValue) {
                style = styleValue;
              }
              // Handle enableCopy attribute
              enableClicktoPaste = enableClicktoPasteValue;
              enableCopy = enableCopyValue === 'false' ? false : true;

              return replacements[key] || defaultValue || '';
            }
          );
          code = code.replace(/<\/inject>/g, '');
          code = code.replace(/</g, '&lt;').replace(/>/g, '&gt;');
          if (enableClicktoPaste) {
            return `<pre class="line-numbers language-none" tabindex="0" data-lang="${getFenceLanguage(infostring)}"><code class="language-none" enableClicktoPaste="${enableClicktoPaste}" style="${style}">${code}</code></pre>`;
          } else {
            return `<pre class="line-numbers language-none" tabindex="0" data-lang="${getFenceLanguage(infostring)}"><code class="language-none" enablecopy="${enableCopy}" style="${style}">${code}</code></pre>`;
          }
        };

        this.markdownService.renderer.html = (htmlTag: string) => {
          htmlTag = this.commonSrv.appendDocsTokenToImages(
            htmlTag,
            this.environment.privateRepoAccessToken
          );
          if (htmlTag === '</inject>') {
            return '';
          }
          const props = { ...this.defaultProps };
          return this.commonSrv.getAllAttributes(
            props,
            htmlTag,
            this.attendeLabDetails,
            this.guideData,
            this.initialDeploymentData,
            this.uniqueName
          );
        };

        this.commonSrv.getImageTag(
          path,
          this.markdownService,
          this.environment.privateRepoAccessToken
        );
        this.commonSrv.getLinks(this.markdownService);

        this.loadMdFiles();

        // const gitdocObserables = this.gitHUbdocs.Files.map((file) =>
        //   this.gitHubSrv.getGitHubData(file.RawFilePath)
        // );
        // combineLatest(gitdocObserables)
        //   .pipe(
        //     takeUntil(this.notifier),
        //     map((resp) =>
        //       resp.map((res, index) => ({
        //         res,
        //         order: this.gitHUbdocs.Files[index].Order,
        //       }))
        //     )
        //   )
        //   .subscribe(
        //     (res) => {
        //       this.labGuideData = res;
        //       this.labGuideData.sort((x, y) => {
        //         return x.order - y.order;
        //       });
        //       setTimeout(() => {
        //         this.handleLabGuideElements(texting);
        //       }, 3000);
        //     },
        //     (err) => {
        //       this.labGuideData = [
        //         { res: 'Error: One or more documents not found', order: 1 },
        //       ];
        //       const code = 'Error - 70018';
        //       this.eventEmitter.debugAlert(code, err.error);
        //     }
        //   );
      }
    } else if (this.labDetail.LabLaunchPageDescription) {
      localStorage.setItem(this.vmTabKey, 'description');
      this.tabView = 'description';
    } else {
      this.tabView = 'environment';
      // this.collapseSideBar.emit();
    }
    this.tabChange.next(this.tabView);
  }

  async completeTheLab(event: string) {
    if (localStorage.getItem(this.splitKey)) {
      this.spliLabIsCompleted.emit(event);
      localStorage.setItem(`delete-lab-${this.voucherCode}`, event);
    }
    this.labIsCompleted.emit(event);
  }

  moveArrayItemToNewIndex(arr, old_index, new_index) {
    if (new_index >= arr.length) {
      let k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
  }
  /**
   * selected tab
   * @param item
   */

  viewTab(item, list, spliceItem: boolean, spliceItem2: boolean) {
    this.tabView = item;
    setTimeout(() => {
      this.handleLabGuideElements('');
    }, 500);
    this.guideTab.forEach((element) => {
      if (element.title == list.title) {
        element.selected = true;
        localStorage.setItem(this.vmTabKey, element.link);
      } else {
        element.selected = false;
      }
    });
    this.tabChange.next(this.tabView);
    if (item === 'guide') {
      this.getLabGuideProgress();
    }
  }

  reFlow() {
    let tabHidden = false;
    const tab_wrapper = $('.resize-tab');
    const wrapper_width = tab_wrapper.width();
    const dropdown_width = tab_wrapper.find('li.dropdown').width();
    let width_sum = 0;
    tab_wrapper.find('>li:not(li.dropdown)').each(function (index, elm) {
      width_sum += $(elm).outerWidth(true);
      if (width_sum + dropdown_width + 10 > wrapper_width) {
        if (
          $(elm).outerWidth(true) <=
            tab_wrapper.find('li.dropdown').outerWidth(true) + 10 &&
          $(elm).index() ===
            tab_wrapper.find('>li:not(li.dropdown)').length - 1 &&
          !tabHidden
        ) {
          $(elm).show();
        } else {
          tabHidden = true;
          $(elm).hide();
        }
      } else {
        $(elm).show();
      }
    });
    const hidden_lists = tab_wrapper.find('>li:not(li.dropdown):not(:visible)');
    if (hidden_lists.length > 0) {
      $('li.dropdown').show();
      tab_wrapper.find('ul.dropdown-menu li').hide();
      hidden_lists.map(function (element) {
        tab_wrapper
          .find('ul.dropdown-menu li#' + hidden_lists[element].id + '-dup')
          .show();
      });
    } else {
      $('li.dropdown').hide();
    }
  }

  handleLabGuideElements(texting) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const defaultProps = { ...this.defaultProps };
    if (texting !== '') {
      $('#guideView img').each(function (index, elm) {
        // Add tab index to all images
        $(elm).attr('tabindex', '0');
        $(elm).addClass('img-click');

        if ($(elm).attr('src') && !$(elm).attr('src').includes('http')) {
          $(elm).attr('src', texting + '/' + $(elm).attr('src'));
        }
      });
    } else {
      $('#guideView img').each(function (index, elm) {
        // Add tab index to all images
        $(elm).attr('tabindex', '0');
        $(elm).addClass('img-click');
      });
    }
    const clickToCopyText = this.translateSrv.instant('COPY');
    const clickToPasteText = this.translateSrv.instant('CLICK_TO_PASTE');
    const fullScreenText = this.translateSrv.instant('FULL_SCREEN');
    const pasteInVM = this.pasteInVM;
    $('#guideView .copydetails').each(function () {
      $(this).find('a').remove();
      let text = $(this).text();
      if (text !== undefined && text !== null && text !== '') {
        text = text.trim();
      }
      const textLength = text.replace(/<\/?span[^>]*>/g, '').length;
      let showPaste: boolean;
      if (textLength && textLength <= 250 && pasteInVM) {
        showPaste = true;
      }
      const ariaLabel = $(this).attr('aria-label');
      $(this).append(
        '<a style="' +
          $(this).attr('style') +
          '" tabindex="0" role="button" aria-label="' +
          (showPaste ? clickToPasteText : clickToCopyText) +
          ' ' +
          ariaLabel +
          '"  data-toggle="tooltip" ' +
          '  title="' +
          (showPaste ? clickToPasteText : clickToCopyText) +
          ' ' +
          ariaLabel +
          '" alt="" id="' +
          (showPaste ? 'pasteInsideVM' : '') +
          '" class="' +
          (showPaste ? 'fa-regular fa-paste' : 'fa-regular fa-clone') +
          ' copyelement">' +
          text +
          '</a>'
      );
      // set tooltip
      $('[data-toggle="tooltip"]').tooltip({
        placement: 'bottom',
        trigger: 'hover',
      });
    });
    $('#guideView .copyPasteDetails').each(function () {
      $(this).find('a').remove();
      let text = $(this).text();
      if (text !== undefined && text !== null && text !== '') {
        text = text.trim();
      }

      const ariaLabel = $(this).attr('aria-label');
      $(this).append(
        '<a id="pasteInsideVM" style="' +
          $(this).attr('style') +
          '" tabindex="0" role="button" aria-label="' +
          clickToPasteText +
          ' ' +
          ariaLabel +
          '"  data-toggle="tooltip" ' +
          '  title="' +
          clickToPasteText +
          ' ' +
          ariaLabel +
          '" alt="" class="fa-regular fa-paste copyelement">' +
          text +
          '</a>'
      );
      // set tooltip
      $('[data-toggle="tooltip"]').tooltip({
        placement: 'bottom',
        trigger: 'hover',
      });
    });
    $('#guideView pre').each(function () {
      if ($(this).find('code')[0]) {
        $(this).find('a').remove();
        const text = $(this).find('code')[0].innerHTML;
        const htmlText = htmlDecode(text);
        const elm = stringToHtml(htmlText);
        let outputValue;
        const props = { ...defaultProps };
        if (elm) {
          const key = elm
            .getAttribute('key')
            ?.replace(/ +/g, '')
            ?.toLowerCase();
          const cloudName = elm
            .getAttribute('cloudname')
            ?.replace(/ +/g, '')
            ?.toLowerCase();

          let deploymentOutputValues;
          let guideDataValues;

          if (
            self.attendeLabDetails.AllocatedTestDriveViewModalDetails.length > 1
          ) {
            deploymentOutputValues =
              self.attendeLabDetails.AllocatedTestDriveViewModalDetails.find(
                (item) => item.FriendlyName?.toLowerCase() === cloudName
              )?.DeploymentOutputValues;
            guideDataValues =
              self.guideData.AllocatedTestDriveViewModalDetails.find(
                (item) => item.FriendlyName?.toLowerCase() === cloudName
              );
          } else {
            deploymentOutputValues =
              self.attendeLabDetails.AllocatedTestDriveViewModalDetails[0]
                ?.DeploymentOutputValues;
            guideDataValues =
              self.guideData.AllocatedTestDriveViewModalDetails[0];
          }

          if (elm.hasAttribute('enableCopy')) {
            props.enableCopy = Boolean(
              elm.getAttribute('enableCopy') === 'true'
            );
          }
          if (elm.hasAttribute('enableClicktoPaste')) {
            props.enableClicktoPaste = Boolean(
              elm.getAttribute('enableClicktoPaste') === 'true'
            );
            props.enableCopy = props.enableClicktoPaste
              ? false
              : props.enableCopy;
          }
          if (elm.hasAttribute('style')) {
            props.style = elm.getAttribute('style');
          }

          if (key) {
            if (deploymentOutputValues && deploymentOutputValues.length > 0) {
              deploymentOutputValues.forEach((item) => {
                const { OutputValues } = item;
                if (
                  OutputValues &&
                  OutputValues.length > 0 &&
                  OutputValues.findIndex(
                    (value) =>
                      value.Name.replace(/ +/g, '').toLowerCase() === key
                  ) > -1
                ) {
                  outputValue = OutputValues.find(
                    (value) =>
                      value.Name.replace(/ +/g, '').toLowerCase() === key
                  );
                }
              });
            }

            // manage the service variable
            if (guideDataValues) {
              const Value = manageServiceVariables(key, guideDataValues);
              if (Value !== '') {
                outputValue = { Value };
              }
            }
          }
        }

        const value = outputValue !== undefined ? outputValue.Value : text;
        if (outputValue !== undefined) {
          $(this).find('code')[0].innerHTML = value;
        }
        // handle css style on variables
        if (props.style) {
          const codeElm = $(this).find('code')[0];
          if (codeElm) {
            $(codeElm).attr('style', props.style);
          }
        }
        const enableClicktoPaste = props.enableClicktoPaste
          ? props.enableClicktoPaste
          : $(this).find('code')[0]?.attributes['enableclicktopaste']?.value;
        const enablecopy =
          $(this).find('code')[0]?.attributes['enablecopy']?.value || true;
        props.enableCopy = enablecopy === 'false' ? false : true;
        enhanceCodeBlock(this, {
          value,
          copyTitle: enableClicktoPaste ? clickToPasteText : clickToCopyText,
          fullScreenTitle: fullScreenText,
          isPaste: !!enableClicktoPaste,
          onFullScreen: (block) => self.codeBlockPopup?.open(block),
        });
      } else {
        const rawText = ($(this).text() || '').trimEnd();
        const escaped = rawText
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;');
        $(this).addClass('line-numbers language-none').attr('tabindex', '0');
        $(this).html(`<code class="language-none">${escaped}</code>`);
        $(this).css('display', 'inline-block');
      }
    });
    $('.selfnavigation').on('click', function () {
      const id = $(this).data('id');
      const elementID = id.replace('#', '');
      const el = document.getElementById(elementID);
      el.scrollIntoView();
    });
  }
  getVmTab(): void {
    // if (localStorage.getItem(this.currentGuideKey)) {
    //   this.p = Number(localStorage.getItem(this.currentGuideKey));
    // }
    this.currentTab = localStorage.getItem(this.vmTabKey);
    if (this.currentTab !== null) {
      this.tabView = this.currentTab;
    } else if (this.guideData.IsGitDocAvailable) {
      this.tabView = 'guide';
    } else {
      this.tabView = 'environment';
    }
    this.maxPages();
    const page = this.p > 0 ? this.p - 1 : 1;
    const path = this.gitHUbdocs.Files[page].RawFilePath;
    const texting = path.substring(0, path.lastIndexOf('/'));
    this.pathFileName = path.split('/').pop();
    setTimeout(() => {
      this.handleLabGuideElements(texting);
    }, 500);
    this.tabChange.next(this.tabView);
  }
  ngOnDestroy(): void {
    localStorage.removeItem('pageNumber' + this.voucherCode);
    this.notifier.next();
    this.notifier.complete();
    unsubscribeCollection(this.subscriptions);
    this.stopPageTimer();
  }

  private updatePreHeights(): void {
    $('#guideView pre').each(function () {
      const heightinPX = $(this).css('height');
      if ($(this).next('a').length > 0) {
        $(this)
          .next('a')
          .css('bottom', parseInt(heightinPX.slice(0, -2)) - 10 + 'px');
      }
    });
  }

  private detectOS(): void {
    const userAgent = window.navigator.userAgent;
    if (/Windows/.test(userAgent)) {
      this.osInfo = 'Windows';
    } else if (/Macintosh/.test(userAgent)) {
      this.osInfo = 'Mac OS';
    } else if (/Android/.test(userAgent)) {
      this.osInfo = 'Android';
    } else if (/Linux/.test(userAgent)) {
      this.osInfo = 'Linux';
    } else if (/iOS/.test(userAgent)) {
      this.osInfo = 'iOS';
    } else {
      this.osInfo = 'Unknown';
    }
  }

  getUngroupQuestionData(data: any) {
    const questData = this.mdPath.find((e) => data.indexOf(e.md) > -1);
    if (questData?.childData) {
      this.userSessionService.isQuestionLoaded$.next(true);
    }
    return questData?.childData;
  }
  getGroupQuestionData(data: any) {
    const questData = this.mdPathGroup.find((e) => data.indexOf(e.md) > -1);
    if (questData?.childData) {
      this.userSessionService.isQuestionLoaded$.next(true);
    }
    return questData?.childData;
  }

  public getlabguideQuestion(): void {
    this.commonServicePT
      .getlabguideQuestion(this.voucherCode, this.pathFileName)
      .subscribe(
        (res: any) => {
          // const res = decryptBackendResponse(encryptRes, this.userSessionService.getOriginalKeyPair().private);
          if (res?.status === 'Error') {
            const code = 'Error - 30052';
            this.notificationService.error(res.message, null);
            this.eventEmitter.debugAlert(code, res.message);
          } else {
            this.commonSrv.appendDocsTokenToImagesDeep(
              res,
              this.environment.privateRepoAccessToken
            );
            const ungroupedQuestions = res.ungroupedQuestions;
            this.mdPath = this.mdPath.map((e: any) => {
              const findQuestFileName = ungroupedQuestions?.find(
                (r: any) => r.questionFileName == e.md
              );
              const question = `<question source="${e.md}" />`;
              e = {
                md: e.md,
                childData: findQuestFileName,
                questionTag: question,
              };
              return e;
            });
            const groupedQuestions = res.groupedQuestions;
            this.mdPathGroup = this.mdPathGroup.map((e: any) => {
              const findgroupFileName = groupedQuestions?.find(
                (r: any) => r.groupFileName == e.md
              );
              const question = `<grouped-questions source="${e.md}" />`;
              e = {
                md: e.md,
                childData: findgroupFileName,
                questionTag: question,
              };
              return e;
            });
          }
        },
        (err) => {
          const code = 'Error - 30053';
          this.eventEmitter.debugAlert(code, err);
        }
      );
  }

  private getSourcePath(inlineQuestionTag): string {
    const regexr = /source="([^"]+)"/;
    const match = regexr.exec(inlineQuestionTag);
    if (match && match.length > 1) {
      const questionMdUrl = match[1];
      return questionMdUrl;
    }
    return '';
  }

  getVideoLink(data: any) {
    const videoLink = this.videoPath.find((e) => data.indexOf(e) > -1);
    return videoLink;
  }

  getVideoWidth(data: any) {
    const width = this.videoWidth.find((e) => data.indexOf(e) > -1);
    return width;
  }

  getVideoHeight(data: any) {
    const height = this.videoHeight.find((e) => data.indexOf(e) > -1);
    return height;
  }

  private getWidth(inlineQuestionTag): string {
    const regexr = /width="([^"]+)"/;
    const match = regexr.exec(inlineQuestionTag);
    if (match && match.length > 1) {
      const width = match[1];
      return width;
    }
    return '';
  }

  private getHeight(inlineQuestionTag): string {
    const regexr = /height="([^"]+)"/;
    const match = regexr.exec(inlineQuestionTag);
    if (match && match.length > 1) {
      const height = match[1];
      return height;
    }
    return '';
  }

  public getLabGuideProgress(): void {
    this.LabSrv.getLabGuideProgress(this.voucherCode).subscribe(
      (labGuides: any) => {
        this.eventSrv.setHeaderProgress(
          labGuides.LabProgressPercentage,
          this.voucherCode
        );
        this.eventSrv.setLabGuideProgress(labGuides);
      }
    );
    this.LabSrv.getAttendeeLab(this.voucherCode).subscribe(
      (res) => {
        this.eventSrv.attendeeLab.next(res)
    });
  }

  private maxPages() {
    const totalPages = this.gitHUbdocs.Files.length;
    const filteredGuides = this.gitHUbdocs.Files.filter(
      (guide) => guide.HasUnlockingRules
    ).map((guide) => guide.Order);
    this.p =
      this.pageNumber > totalPages || Number(this.pageNumber) == 0
        ? 1
        : this.pageNumber;
    if (filteredGuides.includes(Number(this.pageNumber))) {
      this.lockPages();
    }
    if (this.isMylearning) {
      if (getEntityData() === 'courses') {
        this.location.replaceState(
          getEntity() +
            `/` +
            getEntityData() +
            `/${this.clid}/${this.clVcode}/${this.internalId}/${this.voucherCode}/labenvironment/${this.vmurl}/${this.p}`
        );
      } else {
        this.location.replaceState(
          getEntity() +
            `/` +
            getEntityData() +
            `/${this.internalId}/${this.voucherCode}/labenvironment/${this.vmurl}/${this.p}`
        );
      }
    } else {
      if (!this.isSplitScreen) {
        this.location.replaceState(
          `/odl/environment/${this.internalId}/${this.voucherCode}/${this.vmurl}/${this.p}`
        );
      }
    }
  }

  private lockPages() {
    const filteredGuides = this.gitHUbdocs.Files.filter(
      (guide) => guide.HasUnlockingRules
    ).map((guide) => guide.Order);
    if (filteredGuides.includes(Number(this.pageNumber))) {
      let pageNum = Number(this.pageNumber); // Convert page number to number

      // Keep decreasing pageNum while it exists in the array and is greater than 1
      while (filteredGuides.includes(pageNum) && pageNum > 1) {
        pageNum--;
      }
      // Set the final valid page number
      this.p = pageNum;
    } else {
      this.p = this.pageNumber;
    }
    if (this.isMylearning) {
      if (getEntityData() === 'courses') {
        this.location.replaceState(
          getEntity() +
            `/` +
            getEntityData() +
            `/${this.clid}/${this.clVcode}/${this.internalId}/${this.voucherCode}/labenvironment/${this.vmurl}/${this.p}`
        );
      } else {
        this.location.replaceState(
          getEntity() +
            `/` +
            getEntityData() +
            `/${this.internalId}/${this.voucherCode}/labenvironment/${this.vmurl}/${this.p}`
        );
      }
    } else {
      if (!this.isSplitScreen) {
        this.location.replaceState(
          `/odl/environment/${this.internalId}/${this.voucherCode}/${this.vmurl}/${this.p}`
        );
      }
    }
  }
  onDelete(action) {
    this.actionClickEvent.emit(action);
  }

  togglePanel(panelNumber: number): void {
    this.panelStates[panelNumber] = !this.panelStates[panelNumber];
  }
}
